import React from 'react';
import {PromiseMessage} from '../../../../../lib/components';
import {ReactNodeGenerator} from '../../../../../lib/helpers';
import {SlideShowEditStore} from './SlideShowEditStore';

function* renderSlideBody(store: SlideShowEditStore,
                          index: number): ReactNodeGenerator {
  const slide = store.slides[index];
  const first = index === 0;
  const last = index === store.slides.length - 1;

  const {imageUrl, imageFile, imageUpload} = slide;

  if (imageUrl === null) {
    yield (
      <div className="row no-gutters" key="1">
        <div className="col-md-4 col-xs-6">
          <div className="form-group">
            <label>Image</label>
            <input type="file" className="form-control-file"
                   onChange={slide.handleImageFileChange}/>
          </div>
        </div>
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  disabled={imageFile === null || imageUpload?.isPending === true}
                  onClick={slide.uploadImage}>
            Upload
          </button>
        </div>
      </div>
    );
    yield (
      <PromiseMessage key="2"
                      label="Uploading" state={imageUpload} align="right"/>
    );
    yield (
      <div className="row" key="errors">
        <div className="col">
          <div className="alert alert-danger">
            Image not specified
          </div>
        </div>
      </div>);
  }

  if (imageUrl !== null) {
    yield (
      <div className="row" key="3">
        <div className="col">
          <img className="slideshow-image" src={imageUrl} alt=""/>
        </div>
      </div>
    );
  }

  yield (
    <div className="row justify-content-between" key="5">
      <div className="col-auto">
        <button type="button" className="btn btn-primary"
                onClick={() => store.moveBefore(index)}
                disabled={first}>
          <i className="fas fa-angle-double-up"/> Move
        </button>
        <button type="button" className="btn btn-primary"
                onClick={() => store.moveAfter(index)}
                disabled={last}>
          <i className="fas fa-angle-double-down"/> Move
        </button>
      </div>
      <div className="col-auto">
        <button type="button" className="btn btn-primary"
                onClick={slide.clearImage}
                disabled={imageUrl === null}>
          Clear
        </button>
        <button type="button" className="btn btn-warning"
                onClick={() => store.removeSlide(index)}> Remove
        </button>
      </div>
    </div>);
}

export function* slideShowEditStoreRenderer(store: SlideShowEditStore): ReactNodeGenerator {

  for (let index = 0; index < store.slides.length; index++) {
    yield (
      <div className="row" key={index}>
        <div className="col">
          <div className="card">
            <div className="card-body slide">
              {Array.from(renderSlideBody(store, index))}
            </div>
          </div>
        </div>
      </div>);
  }


  yield (
    <div className="row justify-content-end" key="add-slide">
      <div className="col-auto">
        <button type="button" className="btn btn-primary"
                onClick={store.addSlide}>
          Add slide
        </button>
      </div>
    </div>);

  if (store.slides.length === 0)
    yield (
      <div className="row" key="error-no-cards">
        <div className="col text-center">
          <div className="alert alert-danger">
            No cards
          </div>
        </div>
      </div>);

}
